import React, { useState } from "react";

import NewSAVCommande from "../NewTicketSav/NewSAVCommande";
import NewSAVComment from "../NewTicketSav/NewSAVComment";
import UpdateSAVInfos from "./UpdateSavTabContent/UpdateSAVInfos";
import UpdateSAVRevendeur from "./UpdateSavTabContent/UpdateSAVRevendeur";
import SavPreviewAttachments from "../SavPreview/SavPreviewAttachments";
import RevendeurNotFound from "./RevendeurNotFound";
import Favorites from "../../Common/Favorites/Favorites";

const UpdateTicketSAVContent = ({
  activeTab,
  setActiveTab,
  formData,
  setFormData,
  notifications,
}) => {
  const revendeurUser = formData?.users?.find((user) => user.userRole === 0);
  const [scrollableComment, setScrollableComment] = useState();

  switch (activeTab) {
    case "General information":
      return <UpdateSAVInfos formData={formData} setFormData={setFormData} />;
    case "Reseller":
      return revendeurUser ? (
        <UpdateSAVRevendeur formData={formData} />
      ) : (
        <RevendeurNotFound />
      );
    case "AS Order":
      return <NewSAVCommande />;
    case "Attachments":
      return (
        <SavPreviewAttachments
          ticketId={formData.id}
          notificationCount={notifications["Attachments"]}
        />
      );
    case "Exchanges":
      return (
        <NewSAVComment
          scrollableComment={scrollableComment}
          setScrollableComment={setScrollableComment}
          notificationCount={notifications["Exchanges"]}
        />
      );
    case "Notes":
      return (
        <NewSAVComment
          scrollableComment={scrollableComment}
          setScrollableComment={setScrollableComment}
          isAdmin
          notificationCount={notifications.Notes}
        />
      );

    case "Favorites":
      return (
        <Favorites
          view="SAV"
          setActiveTab={setActiveTab}
          setScrollableComment={setScrollableComment}
        />
      );
    // case t("Summary"):
    //   return <NewSAVSummary />;
    default:
      <UpdateSAVInfos />;
  }
};

export default UpdateTicketSAVContent;
